// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4fab93fa","453":"d2864ec4"}[chunkId] + ".chunk.js";
};